<template>
    <ModalComponent
        :name="'borrar-' + taquillero.id"
        :title="'¿Seguro que quieres borrar el ' + taquillero.role + ' de: ' + taquillero.nombre + '?'"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <h2>Datos del {{ taquillero.role }}</h2>
            </div>
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Nombre:</b> {{ taquillero.nombre }}
                    </li>
                    <li class="list-group-item">
                        <b>Email:</b> {{ taquillero.email }}
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold text-uppercase">¿BORRAR {{ taquillero.role }}?</h1>
            </div>
            <div class="col-12 text-center">
                <button type="button" name="button" class="btn btn-primary" @click="borrarTaquillero">SI, BORRAR</button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    export default {
        props: ['taquillero'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.taquillero.id, borrado);
            },
            borrarTaquillero() {
                const params = {
                    filters : {},
                    taquillero_id: this.taquillero.id
                }
                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                });
            }
        },
        components: {
            ModalComponent
        }
    }
</script>